export default "__VITE_ASSET__BCLNtKr___"